module.exports = { "default": require("core-js/library/fn/object/is-extensible"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/is-extensible.js
// module id = 618
// module chunks = 1